/* Move the "Book An Appointment" menu item into the header icons area
   so it sits next to the search/account/cart icons on the right. */
(function () {
  function moveBtn() {
    var btn = document.getElementById('HeaderMenu-book-an-appointment');
    if (!btn) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var node = btn.closest('li') || btn;
    if (node.parentElement === icons) return;
    icons.insertBefore(node, icons.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveBtn);
  } else {
    moveBtn();
  }
})();
